import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotificationsError: (state) => {
      state.error = null;
    },
    setNotificationsLoading: (state, action) => {
      state.loading = action.payload;
    },
    
    // Notification functions - regular reducers like other functions
    setNotifications: (state, action) => {
      state.notifications = Array.isArray(action.payload) ? action.payload : [];
    },

    updateNotification: (state, action) => {
      const payload = action.payload?.data;
      if (!payload) return;

      const { content, heading, metadata } = payload;
      const newNotification = {
        content: content,
        heading: heading,
        metadata: metadata,
        creationDate: dayjs().valueOf(),
      };
      if (!Array.isArray(state.notifications)) {
        state.notifications = [];
      }
      state.notifications.unshift(newNotification);
    },

    updateUnreadNotification: (state, action) => {
      const message = action.payload?.data?.message;
      if (message !== "success" || !Array.isArray(state.notifications)) return;
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        isRead: true,
      }));
    },
  },
});

export const { 
  clearNotificationsError, 
  setNotificationsLoading,
  setNotifications,
  updateNotification,
  updateUnreadNotification,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;

// Selectors
export const selectNotifications = (state) => state.notifications.notifications;
export const selectNotificationsLoading = (state) => state.notifications.loading;
export const selectNotificationsError = (state) => state.notifications.error;
